"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _getIterator = require("@babel/runtime-corejs3/core-js/get-iterator");

var _Array$isArray = require("@babel/runtime-corejs3/core-js-stable/array/is-array");

var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");

var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");

var _Array$from = require("@babel/runtime-corejs3/core-js-stable/array/from");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TreeNode = _interopRequireDefault(require("./_TreeNode"));

var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _tree = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/tree.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty2(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty2(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _Symbol === "undefined" || _getIteratorMethod(o) == null) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = _getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context3; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context3 = Object.prototype.toString.call(o)).call(_context3, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _tree.default);
/**
 *
 *
 * Unlike tree tables, trees are used for rather basic data.
 *
 * USE THE TREE IF:
 *
 * * You need to display the key identifier of hierarchically structured items
 * * Selecting one or more items out of a set of hierarchically structured items is a main use case.
 * * The hierarchy has a restricted number of levels (up to about 12, depending on the content) and items (around 200).
 * * You want to have only one implementation for all devices.
 *
 * DO NOT USE THE TREE IF:
 *
 * * The main use case is to select one item from a very small number of non-hierarchical items,
 * without viewing additional details. In this case, a <a href="/?path=/docs/component-api-select" target="_blank">Select</a> or
 *  <a href="/?path=/docs/component-api-comboboxinput" target="_blank">ComboboxInput</a> might be more appropriate.
 * * Items are not structured hierarchically. Use a <a href="/?path=/docs/component-api-list" target="_blank">List</a> instead.
 * * The hierarchy turns out to have only two levels. In this case, use a grouped list.
 * * The hierarchy turns out to be just a categorization based on several details of the item.
 * In this case, an analytical table provides multi-level grouping. Note that the analytical table is not fully responsive.
 * It is only available for desktops and tablets, so you will need to take an adaptive approach by offering an additional UI for smartphones.
 * * You need to display very deep hierarchies with additional data per item. In this case, use a tree table (not available yet in Fundamental-styles).
 * Note that the tree table is not fully responsive. It is only available for desktops and tablets,
 * so you will need to take an adaptive approach by offering an additional UI for smartphones.
 * * The structure contains more than around 200 items. In this case, use the tree table (not available yet in Fundamental-styles).
 * It is optimized for large item sets and provides better performance. Note that the tree table is not fully responsive.
 * It is only available for desktops and tablets, so you will need to take an adaptive approach by offering an additional UI for smartphones.
 * * You need an overview of a large amount of data. In this case, use a chart.
*/

var Tree = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context, _context2, _classnames;

  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      compact = _ref.compact,
      cssNamespace = _ref.cssNamespace,
      id = _ref.id,
      noBorders = _ref.noBorders,
      emptyText = _ref.emptyText,
      selection = _ref.selection,
      selectionPosition = _ref.selectionPosition,
      props = (0, _objectWithoutProperties2.default)(_ref, ["active", "children", "className", "compact", "cssNamespace", "id", "noBorders", "emptyText", "selection", "selectionPosition"]);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expansionDepth = _useState2[0],
      setExpansionDepth = _useState2[1];

  var _useState3 = (0, _react.useState)({
    'root': {
      id: 'root',
      expanded: true,
      level: 0,
      children: {}
    }
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      tree = _useState4[0],
      setTree = _useState4[1];

  var updateTree = function updateTree(_ref2) {
    var toggledAtLevel = _ref2.toggledAtLevel,
        lastLevelExpanding = _ref2.lastLevelExpanding,
        parentPath = _ref2.parentPath;
    var pathArr = parentPath && parentPath.split && parentPath.split('/') || [];
    var checkTree = tree;
    var checkTreeRoot = checkTree;
    (0, _forEach.default)(pathArr).call(pathArr, function (pathItem, index) {
      var currentItem = checkTree[pathItem];

      if (currentItem && index === pathArr.length - 1) {
        currentItem.expanded = lastLevelExpanding;
      }

      if (!currentItem) {
        checkTree[pathItem] = {
          id: pathItem,
          expanded: lastLevelExpanding,
          level: toggledAtLevel,
          children: {}
        };
        checkTree = checkTree[pathItem].children;
      } else {
        checkTree = currentItem && currentItem.children;
      }
    });
    setTree(checkTreeRoot);
  };

  var getExpandedChildren = function getExpandedChildren(treeNode) {
    if (!treeNode || !treeNode.children || (0, _keys.default)(treeNode.children).length === 0) return 0;
    var childrenIds = (0, _keys.default)(treeNode.children);
    var expandedChildrenCount = (0, _filter.default)(childrenIds) && (0, _filter.default)(childrenIds).call(childrenIds, function (childId) {
      var _treeNode$children$ch;

      return treeNode === null || treeNode === void 0 ? void 0 : (_treeNode$children$ch = treeNode.children[childId]) === null || _treeNode$children$ch === void 0 ? void 0 : _treeNode$children$ch.expanded;
    }).length || 0;
    return expandedChildrenCount;
  };

  var getMaxExpandedNodeLevel = function getMaxExpandedNodeLevel(node) {
    var expandedChildrenCount = getExpandedChildren(node);

    if (expandedChildrenCount < 1) {
      return node.level;
    }

    var maxExpandedLevel = node.level;
    var nodeChildren = (node === null || node === void 0 ? void 0 : node.children) || {};
    var nodeChildrenIds = (0, _keys.default)(nodeChildren);
    var expandedChildrenIds = (0, _filter.default)(nodeChildrenIds).call(nodeChildrenIds, function (childId) {
      var _node$children$childI;

      return node === null || node === void 0 ? void 0 : (_node$children$childI = node.children[childId]) === null || _node$children$childI === void 0 ? void 0 : _node$children$childI.expanded;
    });

    var _iterator = _createForOfIteratorHelper(expandedChildrenIds),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var expandedChildId = _step.value;
        var expandedChild = node === null || node === void 0 ? void 0 : node.children[expandedChildId];
        var expandedChildMaxDepth = getMaxExpandedNodeLevel(expandedChild);

        if (expandedChildMaxDepth > maxExpandedLevel) {
          maxExpandedLevel = expandedChildMaxDepth;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return maxExpandedLevel;
  };

  var treeId = (0, _useUniqueId.default)(id);
  var levelOneNodes = (0, _map.default)(_context = (0, _filter.default)(_context2 = _react.default.Children.toArray(children)).call(_context2, function (child) {
    return child.type && child.type.displayName === 'Tree.Node';
  })).call(_context, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread(_objectSpread({}, child === null || child === void 0 ? void 0 : child.props), {}, {
      level: 1,
      expansionEventBubbler: function expansionEventBubbler(toggledAtLevel, lastLevelExpanding, itemId, parentId, parentPath) {
        updateTree({
          toggledAtLevel: toggledAtLevel,
          lastLevelExpanding: lastLevelExpanding,
          itemId: itemId,
          parentId: parentId,
          parentPath: parentPath
        });
        var newExpansionDepth = getMaxExpandedNodeLevel(tree.root);
        setExpansionDepth(newExpansionDepth);
      },
      parentId: 'root',
      parentPath: 'root',
      selection: selection,
      selectionPosition: selectionPosition,
      treeId: treeId,
      treeActive: active
    }));
  });
  var emptyTree = !(levelOneNodes !== null && levelOneNodes !== void 0 && levelOneNodes.length) > 0;
  var treeClasses = classnames("".concat(cssNamespace, "-tree"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "expanded-level-".concat(expansionDepth), typeof expansionDepth === 'number' && expansionDepth > 0), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-tree--active"), active), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-tree--compact"), compact), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-tree--no-border"), noBorders), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-tree--no-data"), emptyTree), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({
    ref: ref
  }, props, {
    className: treeClasses,
    id: treeId,
    role: "tree"
  }), !emptyTree ? levelOneNodes : /*#__PURE__*/_react.default.createElement("li", {
    "aria-level": "1",
    className: classnames("".concat(cssNamespace, "-tree__item")),
    role: "treeitem"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-tree__item-container"))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-tree__content"))
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(cssNamespace, "-tree__text"))
  }, emptyText)))));
});

Tree.displayName = 'Tree';
process.env.NODE_ENV !== "production" ? Tree.propTypes = {
  /** Set to **true** to make all `TreeNode`s have styles for interaction states (hover, selected, active).*/
  active: _propTypes.default.bool,

  /** React nodes to render within. Nest `TreeNode`s to create multiple levels in the `Tree`.*/
  children: _propTypes.default.node,

  /** Custom classes to add to Tree.*/
  className: _propTypes.default.string,

  /** Set to **true** to apply compact styles.*/
  compact: _propTypes.default.bool,

  /** Set to a **String** value to display when `Tree` is empty, i.e. has no children.*/
  emptyText: _propTypes.default.string,

  /** Set to a **String** value to use as id for root node which is an `<ul>`. If unset, a generate value will be used.*/
  id: _propTypes.default.string,

  /** Set to **true** to remove borders from all level 1 nodes.*/
  noBorders: _propTypes.default.bool,

  /** Set to `multi` to enable selecting multiple selection of `TreeNode`s with Checkboxes.
   *
   * Set to `single` to enable selecting only one of the `TreeNode`s at a time, with radio buttons.
  */
  selection: _propTypes.default.oneOf(['multi', 'single']),

  /** Set to `left` to show selection control before node contents.
   *
   * Set to `right` to show selection control after node contents.
  */
  selectionPosition: _propTypes.default.oneOf(['left', 'right'])
} : void 0;
Tree.defaultProps = {
  active: false,
  selectionPosition: 'left'
};
Tree.Node = _TreeNode.default;

var _default = (0, _withStyles.default)(Tree);

exports.default = _default;